/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr3_EyebrowInputs */

const en_funnel_sq_fr3_eyebrow = /** @type {(inputs: Funnel_Sq_Fr3_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring anything`)
};

const es_funnel_sq_fr3_eyebrow = /** @type {(inputs: Funnel_Sq_Fr3_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae lo que sea`)
};

/**
* | output |
* | --- |
* | "Bring anything" |
*
* @param {Funnel_Sq_Fr3_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr3_eyebrow = /** @type {((inputs?: Funnel_Sq_Fr3_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr3_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr3_eyebrow(inputs)
	return en_funnel_sq_fr3_eyebrow(inputs)
});